export const DISCORD = import.meta.env.VITE_DISCORD_LINK;
export const X = import.meta.env.VITE_X_LINK;
